module.exports = __webpack_public_path__ + "static/media/tumble_video.9072899b.MP4";